import React, {useEffect, useState} from 'react';
import {Provinces} from "@app/constants/Provinces";
import ReactChipInput from "react-chip-input";
import {arrayIncludeItem, arrayToString, optionsToString, stringToArray} from "@app/utils/CommonUtils";
import {cloneDeep} from "lodash";
import {requestSaveEmployer} from "@app/services/EmployerService";
import {ResponseCode} from "@app/constants/Common";
import {toast} from "react-toastify";
import {alertMessage, Messages} from "@app/constants/Messages";
import {validateEmployerInput} from "@pages/employer/common/ValidationUtil";

const EmployerCategoryContent = (props) => {
    const [employer, setEmployer] = useState({});
    const [provinceOptions, setProvinceOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [currentTab, setCurrentTab] = useState('employer-basic-tab');

    const {employerInput, onChange} = props


    const changeSomeStringValueToOption = (inputEmp={}) => {
        const emp = cloneDeep(inputEmp)
        emp.industry = stringToArray(inputEmp.industry)
        emp.function = stringToArray(inputEmp.function)
        return emp
    }

    useEffect(() => {
        if (employerInput) {
            setIsEdit(true)
            const emp = changeSomeStringValueToOption(employerInput)
            setEmployer(emp)
        } else {
            setIsEdit(false)
            setEmployer({})
        }
    }, [employerInput]);

    useEffect(() => {
        if (provinceOptions.length === 0) {
            let provinces = [];
            Provinces.forEach(item => {
                provinces.push({
                    value: item,
                    label: item.charAt(0).toUpperCase() + item.slice(1)
                });
            });
            setProvinceOptions(provinces);
        }
    }, []);

    const onSave= () => {
        if (!validateEmployerInput(employer)) {
            return;
        }
        const body = cloneDeep(employer)
        body.industry = arrayToString(employer.industry)
        body.function = arrayToString(employer.function)
        requestSaveEmployer(body).then((res) => {
            console.log(`Response-save user:${JSON.stringify(res)}`);
            if (res.sts_code === ResponseCode.SUCCESS) {
                const newEmployer = res.content
                employer.id = newEmployer.id
                setEmployer({...employer})
                toast.success(Messages.saveInfoSuccess)
            } else {
                alertMessage(res.sts_code, true, true)
            }
        }).catch((error) => {
            console.log(`Error:${JSON.stringify(error)}`);
        }).finally(() => {
        });
    }

    const changeSomeOptionValueToString = (inputEmployerBasic={}) => {
        const strEmpBasic = cloneDeep(inputEmployerBasic)
        strEmpBasic.industry = arrayToString(inputEmployerBasic.industry)
        return strEmpBasic
    }

    const onChangeEmpCallBack = () => {
        const changeEmployer = changeSomeOptionValueToString(employer)
        if (onChange) {
            onChange(changeEmployer)
        }
    }

    const onAddIndustryFunction = (value, fieldName) => {
        if (!value) {
            return;
        }
        let arr = cloneDeep(employer[fieldName])
        if (!arr) {
            arr = []
        }

        if (!arrayIncludeItem(arr, value)) {
            arr.push(value)
            employer[fieldName] = arr
            setEmployer({...employer})
            onChangeEmpCallBack()
        } else {
            alert('Không được phép nhập các giá trị giống nhau tại cùng 1 trường.')
        }
    }

    const onRemoveIndustryFunction = (index, fieldName) => {
        let arr = cloneDeep(employer[fieldName])
        if (arr && arr.length > 0) {
            if (arr.length === 1) {
                arr = []
            } else {
                arr.splice(index, 1);
            }
            employer[fieldName] = arr
            setEmployer({...employer})
            onChangeEmpCallBack()
        }
    }

    const onChangeEmployerInfo = (fieldName, value) => {
        employer[fieldName] = value
        setEmployer({...employer})

        onChangeEmpCallBack()
    };

    return (
        <div className='card card-default'>
            <div className='card-header'>
                <h3 className='card-title text-bold'>Phân loại</h3>
                <div className='card-tools'>
                    <button type='button' className='btn btn-primary'
                            onClick={() => onSave()}>Save
                    </button>
                </div>
            </div>
            <div className='card-body'>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Industry</label>
                    <div style={{width: '100%'}}>
                        <ReactChipInput
                            classes={`class1 class2 w-100`}
                            chips={employer.industry ? employer.industry : []}
                            onSubmit={value => onAddIndustryFunction(value, 'industry')}
                            onRemove={index => onRemoveIndustryFunction(index, 'industry')}
                        />
                    </div>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Function</label>
                    <div style={{width: '100%'}}>
                        <ReactChipInput
                            classes={`class1 class2 w-100`}
                            chips={employer.function ? employer.function : []}
                            onSubmit={value => onAddIndustryFunction(value, 'function')}
                            onRemove={index => onRemoveIndustryFunction(index, 'function')}
                        />
                    </div>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Thông tin về Employer (to send)</label>
                    <input type='text' className='form-control'
                           value={employer["about_employer_to_send"] ? employer["about_employer_to_send"] : ''}
                           name={"about_employer_to_send"}
                           onChange={event => onChangeEmployerInfo("about_employer_to_send", event.target.value)}/>
                </div>
                <div className='input-group mt-3'>
                    <label className={'w-100'}>Thời gian LV (to send)</label>
                    <input type='text' className='form-control'
                           value={employer["working_time_to_send"] ? employer["working_time_to_send"] : ''}
                           name={"working_time_to_send"}
                           onChange={event => onChangeEmployerInfo("working_time_to_send", event.target.value)}/>
                </div>
            </div>
        </div>
    )
}

export default EmployerCategoryContent;
